import { useMutation } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useDoctorCustomerResetPassword = (customerId: string) => {
  const [mutation, { loading }] = useMutation(
    graphql(`
      mutation resetPasswordForCustomer($customerId: String) {
        resetPassword(customerId: $customerId)
      }
    `),
  );

  const doReset = async () => {
    if (!confirm('Reset customers password and sent via SMS')) {
      return;
    }

    await mutation({
      variables: { customerId },
    });

    alert('Reset password sent via SMS');
  };

  return { doReset, loading };
};
